import { tickerItems } from '@/mocks/homeData';

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-primary-950 text-primary-50">
      <div className="mx-auto flex max-w-[1280px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold text-white">
          <span className="flex h-3 w-3 items-center justify-center">
            <span className="block h-1.5 w-1.5 rounded-full bg-white animate-pulse-dot"></span>
          </span>
          实时更新
        </span>

        <div className="marquee-wrap relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
            {loop.map((item, index) => (
              <span key={index} className="flex items-center gap-2 text-xs text-primary-100/90">
                <i className="ri-flashlight-fill text-primary-300"></i>
                {item}
              </span>
            ))}
          </div>
        </div>

        <a
          href="#join"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-primary-400/60 px-3 py-1 text-xs font-medium text-primary-50 transition hover:bg-primary-500 hover:text-white md:flex"
        >
          <i className="ri-download-2-line"></i>
          下载入口
        </a>
      </div>
    </div>
  );
}